import { Atom, swap } from "@dbeining/react-atom";
import type { AccessDeniedContext } from "../utils/access/accessDeniedTypes";

export const accessDeniedAtom = Atom.of<AccessDeniedContext | null>(null);

export function setAccessDeniedContext(context: AccessDeniedContext | null): void {
    swap(accessDeniedAtom, () => context);
}

/** @deprecated Use setAccessDeniedContext */
export function updateAccessDeniedStateAtom(accessDenied: boolean): void {
    swap(accessDeniedAtom, () => (accessDenied ? { source: "route" } : null));
}
